import 'Styles/modals.scss';
import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';

import {trackGAEvent} from 'Actions/adsActions';

class ModalComponent extends React.Component {
	onClickOutsideWindow = () => {
		if( this.props.isOpen && this.props.onClickOutsideWindow ) {
			this.props.onClickOutsideWindow();
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'modalOverlay', 'uiAction', 'cancel' ) );
		}
	};

	avoidScrollPropagation = ( e ) => {
		e.stopPropagation();
	};

	render() {
		const { isOpen } = this.props;

		if( !isOpen ) {
			return null;
		}

		let className = `modal-window ${ this.props.className ? this.props.className : ''  }`;

		return (
			<div className="modal nolinks nooptimize norewrite" onClick={ this.onClickOutsideWindow } onTouchMove={ this.avoidScrollPropagation }>
				<div className={ className } onClick={( e ) => { e.stopPropagation(); } } >
					<div className="modal-content">
						{ this.props.children }
					</div>
				</div>
			</div>
		);
	}
}

ModalComponent.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClickOutsideWindow: PropTypes.func  // Optional: What to do if the user clicks outside of the modal window
};

export default connect()( ModalComponent );


// WEBPACK FOOTER //
// ./src/components/modals/ModalComponent.js